import { useEffect } from 'react';
import { REQUIRED_COOKIE_MANAGER_COOKIES } from '../constants.js';
import getTrackerInfo from '../utils/getTrackerInfo.js';
import hasConsent from '../utils/hasConsent.js';
const useRemoveUnauthorizedCookies = ({
  cookieValues,
  config,
  trackingPreference,
  removeCookies
}) => {
  useEffect(() => {
    const cookiesToRemove = [];
    Object.keys(cookieValues).forEach(cookieName => {
      const trackerInfo = getTrackerInfo(cookieName, config);
      if (REQUIRED_COOKIE_MANAGER_COOKIES.includes(cookieName)) return;
      if (!trackerInfo) {
        // This cookie is not present in the config. For legal/compliance
        // reasons, any cookies not listed in the config may not be set.
        cookiesToRemove.push(cookieName);
        return;
      }
      if (!hasConsent(cookieName, config, trackingPreference) && trackerInfo.type === 'cookie') {
        cookiesToRemove.push(cookieName);
      }
    });
    removeCookies(cookiesToRemove);
  }, [cookieValues]);
};
export { useRemoveUnauthorizedCookies as default };
//# sourceMappingURL=useRemoveUnauthorizedCookies.js.map
